import React from "react";
//#region types
import { WintSuperkollAPIModel as ApiModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { User } from "models/propTypes/userProfilePropTypes";
import { TranslationKeys } from "translations";
import { DocumentFormTypes } from "models/formTypes";
import { TableRowCommonKeys, TableRowProperties } from "models/propTypes/simpleTableProps";
import { SIEFilesListProps } from "models/propTypes/documentPropTypes";
//#endregion
//#region components
import { RoundButton, TableAsync, useFilterContext, useSearchContext, Icon } from "components/common";
import { useDocumentService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import { IconDefinitionConstants } from "utils/constants";

const SIEFilesList: React.FC<SIEFilesListProps> = (props) => {
  const documentService = useDocumentService();
  const { filter } = useFilterContext<DocumentFormTypes.SIEFilter>();
  const searchContext = useSearchContext();

  const filterFunc = React.useCallback(
    (pagination: WintUtilsWebApi.Filter) =>
      documentService.getSIEFiles(pagination, {
        ...(filter ?? {}),
        fileName: searchContext?.searchText,
      }),
    [filter, searchContext?.searchText]
  );

  const onDownloadClick = async (row: ApiModel.SIEFile) => {
    await documentService.downloadSIEFile(row.id, row.actionType);
  };

  const tableProperties: Partial<Record<keyof TableRowCommonKeys | keyof ApiModel.SIEFile, TableRowProperties>> = {
    filename: {
      description: TranslationKeys.Common.Name,
      formatter: (r: ApiModel.SIEFile) => r.filename,
    },
    uploadedDate: {
      description: TranslationKeys.Common.Changed,
      formatter: (r: ApiModel.SIEFile) => new Date(r.uploadedDate),
    },
    uploadedBy: {
      description: TranslationKeys.Common.HandledBy,
      formatter: (r: ApiModel.SIEFile) => new User(r.uploadedById, r.uploadedBy ?? ""),
    },
    actionType: {
      description: TranslationKeys.Common.Type,
      formatter: (r: ApiModel.SIEFile) =>
        LocalizationHelperInstance.getFormattedMessage(`Document.SIEFileActionType_${r.actionType}`),
    },
    id: {
      description: TranslationKeys.Common.Download,
      formatter: (row: ApiModel.SIEFile) => (
        <RoundButton className={cssExports.tableIconButton} onClick={onDownloadClick.bind(null, row)}>
          <Icon icon={IconDefinitionConstants.WDownload} />
        </RoundButton>
      ),
      alignment: "center",
      width: 20,
      disableSort: true,
    },
  };

  return (
    <TableAsync<ApiModel.SIEFile>
      properties={tableProperties}
      filter={filterFunc}
      pagination={"advanced"}
      orderByProperty="uploadedDate"
      orderByDescending
      reloadKey={props.reloadKey}
    />
  );
};
export default SIEFilesList;
